<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-file-invoice-dollar"></i>
        청구서 그룹 목록
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">청구</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">청구서 그룹</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">지불 날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('', 'paid_at')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d', 'paid_at')">-1일</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w', 'paid_at')">-1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m', 'paid_at')">-1달</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w', 'paid_at')">1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m', 'paid_at')">1달</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.paid_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.paid_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              <!-- <b-button inline variant="warning" @click="so.opt['paid_at_ed'] = ''; so.opt['paid_at_sd'] = ''">Clear</b-button> -->
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">환불 날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('', 'refund_at')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d', 'refund_at')">-1일</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w', 'refund_at')">-1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m', 'refund_at')">-1달</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w', 'refund_at')">1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m', 'refund_at')">1달</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.refund_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.refund_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              <!-- <b-button inline variant="warning" @click="so.opt['paid_at_ed'] = ''; so.opt['paid_at_sd'] = ''">Clear</b-button> -->
            </b-form>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label mb-4" for="opt_invoice_id">청구서 아이디</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-input v-model="so.opt['invoice_id']" @keyup.enter="refresh"></b-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_description">설명</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-input v-model="so.opt['description']" @keyup.enter="refresh"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_group">그룹 이름</label>
        </b-col>
        <b-col v-if="group_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="group_name" class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">초기화</b-button>
          </b-form-group>
        </b-col>
        <b-col v-if="!group_name" class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-button id="ph_search_group" :variant="group_name ? 'primary' : 'add'" @click="chainGroup = true">그룹 선택</b-button>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_group">파트너 이름</label>
        </b-col>
        <b-col v-if="partner_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="partner_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="partner_name" class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('partner')">초기화</b-button>
          </b-form-group>
        </b-col>
        <b-col v-if="!partner_name" class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-button id="ph_search_partner" :variant="partner_name ? 'primary' : 'add'" @click="chainPartner = true">파트너 선택</b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">지불 실패</label>
        </b-col>
        <!-- <c-switch color="info" label size="sm" v-model="so.opt['is_failed']" @change="change_failed" /> -->
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label size="sm" v-model="so.opt['is_failed']" @change="change_failed" >
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">지불 완료</label>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label size="sm" v-model="so.opt['is_paid']" @change="change_done">
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">환불</label>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label size="sm" v-model="so.opt['is_refunded']" @change="change_refunded">
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" @change="refresh" name="ph_search_opt_type">
              <b-form-radio value="and">모두 일치</b-form-radio>
              <b-form-radio value="or">최소 한개 이상 일치</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col sm="2">
        <span class="badge badge_border_primary mb-2">전체 : <span style="padding-left: 1.3rem"></span>{{model.total_paid.toString().padStart(10, nbsp) | dollar}}</span>
        <br>
        <span class="badge badge_border_info mb-2">지불 : <span style="padding-left: 1.3rem"></span>{{model.paid.toString().padStart(10, nbsp) | dollar}}</span>
        <br>
        <span class="badge badge_border_warning mb-2">미지불 : <span style="padding-left: 0.5rem"></span>{{model.not_paid.toString().padStart(10, nbsp) | dollar}}</span>
      </b-col>
      
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || '찾기'" v-model="so.sk" @change="sv_reset">
              <option disabled value="">검색</option>
              <option value="partner.username">파트너</option>
              <option value="service.service_name">서비스</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" :disabled="so.adv" v-if="so.sk == 'service.service_name'" @change="refresh" v-model="so.sv">
              <option v-for="(item, index) in codes.service_name" :key="index" :value="item">{{item}}</option>
            </select>
            <input type="text" class="form-control col-xl-12" name="input" id="input" v-if="so.sk != 'service.service_name'" :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()">
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1 mt-1" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2"  @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <!-- <div class="mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">삭제된 항목 숨기기</b-checkbox>
          </div> -->
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">표시되는 개수 : 기본 15개</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <b-tooltip class="w-100" block target="tooltip-target-1" triggers="hover">(?) : 지불 내역</b-tooltip>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
        <b-table class="table table_add table-striped" id="tooltip-target-1" triggers="hover" striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
          :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" @row-clicked="goDetail" style="cursor:pointer;">
          <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
          <template slot="apply_date" slot-scope="row">
            <span v-if="row.item.apply_date == 'string'">-</span>
            <span v-else>{{ row.item.apply_date | sdate }}</span>
          </template>
          <template slot="partner" slot-scope="row">
            {{row.item.partner ? row.item.partner.username : '-'}}
          </template>
          <template slot="group" slot-scope="row">
            {{row.item.group ? row.item.group.groupname : '-'}}
          </template>
          <template slot="service" slot-scope="row">
            <b-badge v-if="row.item.service.service_name" :variant="row.item.service.service_name == 'Basic' ? 'primary' : 'success'">{{row.item.service.service_name }}</b-badge>
            <span v-else>-</span>
          </template>
          <template slot="price" slot-scope="row">
            <span>{{(row.item.total_price + row.item.total_paid) | dollar}}</span>
            <b-badge style="cursor:pointer" @click="modal_history(row.item.history)" v-if="row.item.is_paid == false && row.item.total_paid" variant="primary">?</b-badge>
          </template>
          <template slot="status" slot-scope="row">
            <b-badge v-if="row.item.is_paid" variant="success">지불</b-badge>
            <b-badge v-else-if="row.item.is_refunded" variant="warning">환불</b-badge>
            <b-badge v-else-if="row.item.is_failed" variant="danger">지불 실패</b-badge>
            <b-badge v-else-if="!row.item.is_paid && !row.item.is_refunded && !row.item.is_failed" variant="secondary">-</b-badge>
          </template>
        </b-table>
      </div>
    </div>
  </div>
  <!--//-------------------------------------------------------------------------리스트출력-->
  <!--//-------------------------------------------------------------------------Pagination-->
  <div class="mt30">
    <b-pagination class="pagination justify-content-center" size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
  </div>
  <!--//-------------------------------------------------------------------------Pagination-->
  <!-- start modal -->
  <b-modal title="그룹을 찾고 선택" size="xl" v-model="chainGroup" @ok="chainGroup = false" ok-only cancel-variant="info">
    <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
  </b-modal>
  <!-- start modal -->
  <b-modal title="파트너 찾기 및 선택" size="xl" v-model="chainPartner" @ok="chainPartner = false" ok-only cancel-variant="info">
    <partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @selected="setPartner"></partner-List>
  </b-modal>
  <!-- start modal -->
  <b-modal title="부분 결제 내역" size="xl" v-model="confirm_payment_history" @ok="confirm_payment_history = false" ok-only ok-variant="outline-primary" ok-title="확인">
    <!-- {"purchased_at":"2020-07-30T05:20:58.965844Z","action":"partner payment","pg_name":"f1","pg":"credit","price":10.0} -->
    <ul>
      <!-- TODO : 테이블로 예쁘게 해야 함 -->
      <li v-for="item in payment_history" v-bind:key="item.id" v-bind:class="{ strong: item.hp > 300 }">
        <p v-if="item && item.payer">
          <!-- paypal -->
          <!-- {{item}} -->
          [결제 날짜:{{item.purchase_units[0].payments.captures[0].create_time | datetime}}]
          [회사:{{item.payer.email_address}}]
          [작업:{{item.purchase_units[0].description}}]
          [방법:{{item.pg}}]
          [가격:{{item.purchase_units[0].amount.value}}]
          [통화:{{item.purchase_units[0].amount.currency_code}}]
          [국가:{{item.payer.address.country_code}}]
        </p>
        <p v-else>
          <!-- boot_pay or credit -->
          [결제 날짜:{{item.purchased_at | datetime}}]
          [회사:{{item.pg_name}}]
          [작업:{{item.action}}]
          [방법:{{item.pg}}]
          [가격:{{item.price}}]
          [통화:{{'KRW'}}]
          [국가:{{'KR'}}]
          <!-- country_code, currency_code -->
        </p>
      </li>
    </ul>
  </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>